// src/lib/festival-families.js — groepeer festival-variant-rijen naar families.
//
// Achtergrond: in `config.rollen_festival` staat elke variant als aparte rij
// (Medewerker Productie A/B, Hoofd Productie A/B/C, Algemeen Directeur A t/m E,
// …). De gebruiker kiest in step1 een familie zonder letter; de variant (A t/m
// E) wordt in step2 bepaald via een directe knop of de criteria-modal uit het
// Functiehandboek. Deze helper dedupliceert op runtime — geen DB-migratie
// nodig.

const VARIANT_RE = / ([A-E])$/;

export function stripVariantLetter(rolNaam) {
  return rolNaam.replace(VARIANT_RE, "");
}

function variantLetterVan(rolNaam) {
  const m = rolNaam.match(VARIANT_RE);
  return m ? m[1] : null;
}

// Groepeer raw festival-rollen tot families. Behoudt veld-shape compatibel met
// step1 (rol, dep, niveaus, omschrijving, aliases) zodat de bestaande rendering
// en match-sorter direct werkt; voegt familie-specifieke velden toe.
export function buildFestivalFamilies(rollenFestival) {
  const map = new Map();

  for (const r of rollenFestival || []) {
    const familie = stripVariantLetter(r.rol);
    const variant = variantLetterVan(r.rol); // "A" | "B" | "C" | null
    const key = `${r.dep}::${familie}`;

    if (!map.has(key)) {
      map.set(key, {
        rol: familie,            // step1 toont `rol` → toon familienaam
        familie,                 // expliciet voor downstream gebruik
        dep: r.dep,
        omschrijving: r.omschrijving || "",
        aliases: [],
        variant_schalen: {},
        niveaus: [],
        heeftVarianten: false,
        _rawNamen: [],           // voor debugging / search-context
      });
    }

    const fam = map.get(key);
    const schaal = Array.isArray(r.niveaus) && r.niveaus.length
      ? r.niveaus[0]
      : r.niveau;

    if (variant) {
      fam.variant_schalen[variant] = schaal;
      fam.heeftVarianten = true;
    } else {
      fam.variant_schalen._ = schaal;
    }

    if (!fam.niveaus.includes(schaal)) fam.niveaus.push(schaal);
    if (!fam.omschrijving && r.omschrijving) fam.omschrijving = r.omschrijving;

    // Volledige variantnaam blijft doorzoekbaar (zodat user die "Medewerker
    // Productie B" intypt nog steeds match krijgt op de familie).
    fam.aliases.push(r.rol);
    fam._rawNamen.push(r.rol);

    // Origin-aliases samenvoegen
    if (Array.isArray(r.aliases)) {
      for (const a of r.aliases) {
        if (!fam.aliases.includes(a)) fam.aliases.push(a);
      }
    }
  }

  // Sorteer niveaus binnen elke familie + verwijder duplicates uit aliases
  for (const fam of map.values()) {
    fam.niveaus.sort((a, b) => Number(a) - Number(b));
    fam.aliases = [...new Set(fam.aliases)];
  }

  return [...map.values()];
}

// Helper voor step2: gegeven familie + variant-letter → schaal.
// Bij rollen zonder varianten: gebruik `_` (variant is null/irrelevant).
export function schaalUitVariant(familie, variant) {
  if (!familie) return null;
  if (familie.heeftVarianten) {
    return variant ? familie.variant_schalen[variant] : null;
  }
  return familie.variant_schalen._;
}
